export const apiKey = "3ViTeM6CqXky65aZurz5qQAR5zQEvnM6";

export const apiUrl = "https://api.giphy.com/v1";
